/**
 * Device detection composable
 * Detects device type and capabilities based on user agent and browser features
 */

// Check for touch capability using various methods
// Note: Some properties are non-standard and may not exist in all browsers
type LegacyNavigatorTouchPoints = Navigator & {
  MaxTouchPoints?: number
  msMaxTouchPoints?: number
}

type UseDeviceDetectResult = {
  touchable: boolean
  isApple: boolean
  isAndroid: boolean
  isIPad: boolean
  isIPhone: boolean
}

function isTouchable (): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const navigatorWithLegacyTouchPoints = navigator as LegacyNavigatorTouchPoints

  return (
    ('ontouchstart' in window)
    || ((navigatorWithLegacyTouchPoints.MaxTouchPoints ?? 0) > 0)
    || ((navigatorWithLegacyTouchPoints.msMaxTouchPoints ?? 0) > 0)
  )
}

function getUserAgent (): string {
  if (typeof navigator === 'undefined') {
    return ''
  }

  return navigator.userAgent.toLowerCase()
}

export const useDeviceDetect = (): UseDeviceDetectResult => {
  const userAgent = getUserAgent()

  return {
    touchable: isTouchable(),
    isApple: userAgent.includes('mac os x'),
    isAndroid: userAgent.includes('android'),
    isIPad: userAgent.includes('ipad'),
    isIPhone: userAgent.includes('iphone'),
  }
}
